// extracted by mini-css-extract-plugin
export default {"valid":"validItem_valid__GLyEZ"};